import { getPlacementById, getPlacementDataViewConfig } from 'src/api';
import { PlacementActions } from 'src/store/placement/actions';
import { PlacementViewConfigActions } from 'src/store/placementViewConfig/actions';
import { useGetAuthData } from 'src/hooks/use-get-auth-data';
import { useBuildType } from 'src/hooks/_use_build_type';
import { useDispatch, useSelector } from 'react-redux';
import { useLanguageState } from 'src/hooks/useLanguageState';
import { useEffect, useState } from 'react';
import { IViewConfig, UtilityButtonTypeEnum } from 'src/typings/viewConfig';
import { getPlacementViewConfig } from 'src/store/placementViewConfig/selector';

export const useViewConfig = () => {
  const { getJWT } = useGetAuthData();
  const jwt = getJWT();
  const { isCrossTable } = useBuildType();
  const dispatch = useDispatch();
  const { currentAppLanguage } = useLanguageState();
  const [isFavoritesEnabled, setIsFavoritesEnabled] = useState<boolean>(false);
  const [isPaymentPlansSeparated, setIsPaymentPlansSeparated] = useState<boolean>(false);
  const placementViewConfig = useSelector(getPlacementViewConfig);

  useEffect(() => {
    if (placementViewConfig?.headerSection) {
      checkIsFavoritesEnabled(placementViewConfig);
      checkIsPaymentPlansSeparated(placementViewConfig);
    }
  }, [placementViewConfig]);

  const getViewConfig = (placementId: string): Promise<IViewConfig> => {
    return new Promise((resolve, reject) => {
      getPlacementById(jwt, placementId)
        .then(async ({ data: placementRes }) => {
          const { data: placementViewConfigRes } = await getPlacementDataViewConfig(
            placementRes.placementType.id,
            isCrossTable ? 'crosstable' : 'module',
            true,
          );
          const value = placementViewConfigRes['hydra:member'][0];
          resolve(value);
          dispatch(PlacementActions.setPlacementData(placementRes));
          dispatch(PlacementViewConfigActions.setPlacementViewConfig({ ...value, lang: currentAppLanguage, placement: placementRes }));
        })
        .catch((err) => reject(err));
    });
  };

  const checkIsFavoritesEnabled = (conf: IViewConfig) => {
    conf.headerSection.utilityButtons.forEach((button) => {
      if (button.applicationProperty.systemName === UtilityButtonTypeEnum.addToFavorites) {
        setIsFavoritesEnabled(!button.isHidden);
      }
    });
  };

  const checkIsPaymentPlansSeparated = (conf: IViewConfig) => {
    let result = false;
    conf.headerSection.utilityButtons.forEach((button) => {
      if (button.applicationProperty.systemName === UtilityButtonTypeEnum.separatedPlacementPlans) {
        result = !button.isHidden;
      }
    });
    setIsPaymentPlansSeparated(result);
    return result;
  };

  return {
    isFavoritesEnabled,
    isPaymentPlansSeparated,
    checkIsPaymentPlansSeparated,
    getViewConfig,
  };
};
